module.exports = __webpack_public_path__ + "img/builder-31.69517af9.jpg";